import { IconButton, Stack } from "@mui/material";

import ViewIcon from "../../../../assets/ViewIcon.svg";
import DownloadIcon from "../../../../assets/DownloadBlueIcon.svg";
import DeleteIcon from "../../../../assets/DeleteRedIcon.svg";

export default function DocumentActionIcons({
  doc,
  onView,
  onDownload,
  onDelete,
  disableDelete,
}: any) {
  return (
    <Stack direction="row" spacing={1}>
      <IconButton
        edge="end"
        aria-label="view"
        color="primary"
        onClick={() => onView(doc)}
      >
        <img src={ViewIcon} alt="View" />
      </IconButton>
      <IconButton
        edge="end"
        aria-label="download"
        color="primary"
        onClick={() => onDownload(doc)}
      >
        <img src={DownloadIcon} alt="Download" />
      </IconButton>
      <IconButton
        edge="end"
        aria-label="delete"
        color="error"
        onClick={() => onDelete(doc)}
        disabled={!!disableDelete}
      >
        <img src={DeleteIcon} alt="Delete" />
      </IconButton>
    </Stack>
  );
}
